export const RegexConstants = {
  NUMBER: '^[0-9]*$',
  HEIGHT_INCHES: '^([0-9]|[1][0-1])$',
  ZIP_CODE: '^\\d{5}(-\\d{4})?$',
  PASSWORD: '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&#~^()+-=])[A-Za-z\d$@$!%*?&#~^()+-=].{8,}',
  MONTHS: '^([0-9]|[1][0-1])$',
  MONEY: '^\\s*-?\\d+(\.\\d{1,2})?\\s*$',
  URL: '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?',
  SSN: '\\d{9}',
  SSN_FORMATED: '\\d{3}[\-]\\d{2}[\-]\\d{4}',
  PHONE_FORMATED: '\\d{3}[\-]\\d{3}[\-]\\d{4}',
  FILTER_PAG_REGEX: /[^0-9]/g,

}
